export default "__VITE_ASSET__4zKahE1c__"